import React, { useEffect, useState } from "react";
import Select from "react-select";
import { countries } from "countries-list";
import { useTranslation } from "react-i18next";

const formatOptionLabel = (data) => (
  <div className="flex text-center text-14 w-full px-4">
    <span className="pr-8 text-18">{`${data.emoji}`}</span>
    <span className="pr-8">{`${data.native}`}</span>
    <span>{data.name}</span>
  </div>
);

const CountryPicker = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [formattedCountries] = useState(
    Object.keys(countries).map((code) => ({
      label: countries[code].name,
      value: code,
      ...countries[code],
    })).sort((a, b) => a.label.localeCompare(b.label))
  );

  useEffect(() => {
    setOptions(formattedCountries);
    setValue(
      formattedCountries.filter(
        (country) =>
          country.name === props.getCountry ||
          country.value === props.getCountry
      )
    );
  }, [formattedCountries, props.getCountry]);

  const filterOption = (option, inputValue) => {
    if (inputValue.length === 0) return true;

    return (
      option.value.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  return (
    <div className="w-full h-full relative">
      {options.length !== 0 && value && (
        <Select
          autoFocus
          options={options}
          value={value}
          onChange={props.countryHandler}
          components={{
            Placeholder: () => t("ENTER_COUNTRY"),
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          isSearchable={true}
          isClearable={true}
          filterOption={filterOption}
          styles={{
            control: (styles) => ({
              ...styles,
              backgroundColor: "transparent",
              width: "100%",
              height: "50px",
              paddingLeft: "40px",
              paddingRight: "10px",
              outline: "none",
              border: "none",
              borderColor: "inherit",
              boxShadow: "none",
              position: "fixed",
              color: props.styles?.color,
              ":focused": {
                outline: "none",
                border: "none",
              },
              ":hover": {
                outline: "none",
                border: "none",
                boxShadow: "none",
              },
              ":active": {
                outline: "none",
                border: "none",
              },
              ":focus": {
                outline: "none",
                border: "none",
              },
            }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                textAlign: "left",
                display: "inline-flex",
                width: "100%",
                color: props.styles?.color,
                backgroundColor: (isSelected || isFocused) ? '#B2D4FF' : '#FFFFFF',
              };
            },
            menu: (styles) => {
              return {
                display: "inline-flex",
                width: "100%",
                marginTop: "50px",
              };
            },
            menuList: (styles) => {
              return {
                ...styles,
                width: "100%",
                maxHeight: "calc(100vh - 50px)",
                borderTop: "1px #e1e1e1 solid",
              };
            },
            indicatorContainer: (styles) => {
              return {
                ...styles,
                padding: "0px",
              };
            },
            indicatorsContainer: (styles) => {
              return {
                ...styles,
                display: "none",
              };
            },
            valueContainer: (styles) => {
              return {
                ...styles,
                display: "block",
              };
            },
            input: (styles) => {
              return {
                ...styles,
                width: "100%",
                // height: "44px",
                outline: "none",
                border: "none",
                fontSize: "14px",
                display: "block",
                ":active": {
                  outline: "none",
                  border: "none",
                },
                ":focus": {
                  outline: "none",
                  border: "none",
                },
                ":focused": {
                  outline: "none",
                  border: "none",
                },
                ":hover": {
                  outline: "none",
                  border: "none",
                  boxShadow: "none",
                },
              };
            },
          }}
          formatOptionLabel={formatOptionLabel}
          menuIsOpen
        />
      )}
    </div>
  );
};

export default CountryPicker;
